/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-01-25 16:42:54
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-15 12:21:59
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Modal/WarningModal.tsx
 */
import Modal from './Modal';
import css from './Modal.less';
import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import Footer from './ModalFooter';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Warning = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const {
    header,
    onOk,
    okText,
    onCancel,
    cancelText,
    children,
    visible,
    ...rest
  } = props;
  const title = (
    <div className={css.modalHeader}>
      <InfoCircleFilled
        className={css.headerIcon}
        style={{ color: '#ff695f' }}
      />
      {header}
    </div>
  );
  return (
    <Modal
      className={css.themeHeader}
      visible={visible}
      title={title}
      onCancel={onCancel}
      cancelText={getI18n('general.cancel')}
      {...rest}>
      <div className={css.contentContainer}> {children}</div>
      <Footer
        okClassName={css.dangerousBtn}
        onOk={onOk}
        okText={okText}
        cancelText={cancelText}
        onCancel={onCancel}
      />
    </Modal>
  );
};
export default Warning;
